/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { LinqService, QueryOptions } from 'linquest'
import {
  PerformanceFormTemplateGroupDto,
  PerformanceFormTemplateGroupLightDto,
  PerformanceFormTemplateGroupTranslatedDto,
  YearParameter
} from './models'

import { IAjaxProvider } from 'jinqu'

/**
 * PerformanceFormTemplateGroupApi - API class
 */
export class PerformanceFormTemplateGroupApi extends LinqService {
  /**
   * Creates a new PerformanceFormTemplateGroupApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider)
  }

  /**
   * @param dto
   */
  addOrUpdateAsync(dto?: PerformanceFormTemplateGroupDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroup/AddOrUpdateAsync`
    let query = this.createQuery<any>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set body parameter
    options.data = dto
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param id
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroup/DeleteAsync`
    let query = this.createQuery<any>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param id
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroup/GetAsync`
    let query = this.createQuery<PerformanceFormTemplateGroupDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param id
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroup/GetTranslatedAsync`
    let query = this.createQuery<PerformanceFormTemplateGroupTranslatedDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param performanceFormTepmlateGroupId
   */
  isUsedBefore(performanceFormTepmlateGroupId?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroup/IsUsedBefore`
    let query = this.createQuery<boolean>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({
      key: 'performanceFormTepmlateGroupId',
      value: performanceFormTepmlateGroupId && performanceFormTepmlateGroupId.toString()
    })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroup/List`
    let query = this.createQuery<PerformanceFormTemplateGroupDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    query = query.withOptions(options)

    return query
  }

  /**
   */
  getPerformanceFormTemplateGroupsLightAsync(options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroup/GetPerformanceFormTemplateGroupsLightAsync`
    let query = this.createQuery<PerformanceFormTemplateGroupLightDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    query = query.withOptions(options)

    return query
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroup/ListTranslated`
    let query = this.createQuery<PerformanceFormTemplateGroupTranslatedDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    query = query.withOptions(options)

    return query
  }

  /**
   * @param dto
   */
  saveAsync(dto?: PerformanceFormTemplateGroupDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroup/SaveAsync`
    let query = this.createQuery<any>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set body parameter
    options.data = dto
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param performanceFormTemplateGroupId
   * @param performanceFormOperationYearId
   */
  createNewPerformanceFormTemplateGroupFromCopy(
    performanceFormTemplateGroupId?: string,
    yearParams?: YearParameter,
    options?: QueryOptions
  ) {
    // create query
    const url = `/PerformanceFormTemplateGroup/CreateNewPerformanceFormTemplateGroupFromCopy`
    let query = this.createQuery<boolean>(url)

    // initialize options
    options = options || {}
    options.method = 'POST' // Change to POST
    options.headers = options.headers || {}

    options.data = {
      performanceFormTemplateGroupId: performanceFormTemplateGroupId,
      yearParams: yearParams
    }

    query = query.withOptions(options)

    return query.firstAsync()
  }
}
